import { FunctionOr } from '../types/FunctionOr';

export const unwrap = <T>(valueOrUpdater: FunctionOr<T>, prevState: T) => (valueOrUpdater instanceof Function ? valueOrUpdater(prevState) : valueOrUpdater);
